import i18n from 'services/i18n';

export const VALIDATE_FUNCTIONS = {
  required: value => !value && i18n.t('validation:fieldRequired'),
  integerPositive: value => !/^[1-9][0-9]*$/.test(value) && i18n.t('validation:integerPositive'),
};
